module.exports = __webpack_public_path__ + "static/img/girl.b369370.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mycenter/girl.png
// module id = K/3t
// module chunks = 0